import React, { useState, useMemo, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Heading,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Spinner,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import moment from "moment";
import "moment/locale/pt-br";
import { Link } from "react-router-dom";
import { DeleteIcon, SearchIcon } from "@chakra-ui/icons";

const Motoristas = () => {
  const [downloadDados, setDownloadDados] = useState(false);
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const colecoes = [
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/BARRA GRANDE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/BOIPEBA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/GAMBOA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/VALENÇA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CAIRU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CRUZEIRO DE LAJE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/GANDU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/CAMAMU",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/JIQUIRIÇÁ",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/LAJE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/MARAÚ",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/MUTUÍPE",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/ITAMARATY",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/PALMA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/NILO PEÇANHA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/UBAÍRA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/TEOLÂNDIA",
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/WENCESLAU",
  ];

  const getDados = async () => {
    setLoading(true);
    setDownloadDados(true);
    const promises = colecoes.map(async (colecao) => {
      const snapshot = await getDocs(collection(db, colecao));
      return snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        colecao,
      }));
    });
    const dados = await Promise.all(promises);
    setDados(dados.flat());
    setLoading(false);
  };

  return (
    <>
      {!downloadDados && (
        <Button mb={3} colorScheme="green" onClick={getDados} width="full">
          CARREGAR TODOS DADOS
        </Button>
      )}
      {loading && <Spinner size="lg" />}
      {dados.map((carro) => (
        <Carro key={carro.id} carro={carro} />
      ))}
    </>
  );
};

const Carro = ({ carro }) => {
  const [motoristas, setMotoristas] = useState([]);

  useEffect(() => {
    const getMotoristas = async () => {
      const snapshot = await getDocs(
        collection(db, carro.colecao, carro.id, "Motoristas")
      );
      const dados = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setMotoristas(dados);
    };

    getMotoristas();
  }, [carro]);

  const motorista = motoristas[0] || {};
  const diasVencimento = moment(motorista.cnh_validade).diff(moment(), "days");
  const validadeCNHFormatada = moment(motorista.cnh_validade)
    .locale("pt-br")
    .format("L");

  if (!motoristas.length) {
    return null;
  }

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      overflow="hidden"
      variant="outline"
      key={motorista.id}
      my={"25px"}
      boxShadow="lg"
      rounded="md"
      borderColor={diasVencimento < 0 ? "red" : null}
    >
      <Stack>
        <CardBody>
          <Heading size="md" py="3">
            {motorista.nome}
          </Heading>

          <Text py="1">CNH: {motorista.cnh}</Text>
          <Text py="1">CATEGORIA: {motorista.cnh_categoria}</Text>
          <Text py="1">
            VENCIMENTO:{" "}
            {motorista.cnh_validade
              ? validadeCNHFormatada
              : " Validade não informada"}
          </Text>
          <Text py="1">FILIAL: {carro.Carro.filial} </Text>
          <Text py="1">CARRO: {carro.Carro.placa} </Text>
          <Text py="1">ID DO CARRO: {carro.id} </Text>
          <Text py="1">ID DO MOTORISTA: {motorista.id} </Text>
          {diasVencimento > 15 ? (
            <Text pt={1}>Faltam {diasVencimento} dias para vencer a CNH</Text>
          ) : (
            <Text pt={1}>Vencida há {Math.abs(diasVencimento)} dias</Text>
          )}
        </CardBody>

        <CardFooter>
          <Link to={`/filial/${carro.Carro.filial}/carro/${carro.id}`}>
            <Button colorScheme="blue">Acessar carro responsável</Button>
          </Link>
        </CardFooter>
        {diasVencimento <= 0 ? (
          <Flex justifyContent="center" flex={1}>
            <Alert
              justifyContent="center"
              status="error"
              width="100%"
              rounded="md"
              borderColor="red.500"
            >
              <AlertIcon />
              {diasVencimento >= 0
                ? `CNH Vencida há ${diasVencimento} dias`
                : `CNH vencida há ${Math.abs(diasVencimento)} dias`}
            </Alert>
          </Flex>
        ) : diasVencimento <= 15 ? (
          <Flex justifyContent="center" flex={1}>
            <Alert
              justifyContent="center"
              status="warning"
              width="100%"
              rounded="md"
              borderColor="yellow.500"
            >
              <AlertIcon />
              CNH irá vencer em {diasVencimento} dias
            </Alert>
          </Flex>
        ) : null}
      </Stack>

      <Image
        marginLeft="auto"
        objectFit="contain"
        maxWidth="300px"
        maxHeight="300px"
        src={motorista.cnh_image}
        alt="motorista-img"
      />
    </Card>
  );
};

export default Motoristas;
